import { useRuntime } from './useRuntime'

export const useBaseNavigate = () => {
  const { useBaseNavigate: UBN } = useRuntime()
  if (UBN) {
    return UBN()
  }
}
